module.exports = __webpack_public_path__ + "img/card.2632947e.png";